'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var Avatar = require('../../01.atoms/Avatar/Avatar.js');
var Banner = require('../../01.atoms/Banner/Banner.js');
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-contact-card',
    cnWide = "".concat(CLASSNAME, "--wide"),
    cnBorder = "".concat(CLASSNAME, "__border"),
    cnHeader = "".concat(CLASSNAME, "__header"),
    cnWrapper = "".concat(CLASSNAME, "__wrapper"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnBanner = "".concat(CLASSNAME, "__banner"),
    cnContactHeader = "".concat(CLASSNAME, "__contact-header"),
    cnName = "".concat(CLASSNAME, "__name"),
    cnImage = "".concat(CLASSNAME, "__image"),
    cnInfo = "".concat(CLASSNAME, "__info"),
    cnInfoItem = "".concat(CLASSNAME, "__info-item"),
    cnContactList = "".concat(CLASSNAME, "__contact-list"),
    cnContactListLink = "".concat(cnContactList, "__link");
/**
 * 
 */

var ContactCard = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(ContactCard, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(ContactCard);

  function ContactCard() {
    _rollupPluginBabelHelpers.classCallCheck(this, ContactCard);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(ContactCard, [{
    key: "renderContactLink",
    value: function renderContactLink() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          label = _ref.label,
          url = _ref.url;

      var icon = arguments.length > 1 ? arguments[1] : undefined;

      if (!(label && url && icon)) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement(ButtonLink, {
        className: cnContactListLink,
        iconLeft: icon,
        link: url,
        title: label,
        target: "_blank"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          labelBanner = _this$props.labelBanner,
          labelBack = _this$props.labelBack,
          showBanner = _this$props.showBanner,
          imageUrl = _this$props.imageUrl,
          name = _this$props.name,
          address = _this$props.address,
          opening = _this$props.opening,
          contactLinks = _this$props.contactLinks,
          subline = _this$props.subline,
          showBackButton = _this$props.showBackButton,
          wide = _this$props.wide,
          onBack = _this$props.onBack,
          classes = classNames(CLASSNAME, className, _rollupPluginBabelHelpers.defineProperty({}, cnWide, wide));
      return /*#__PURE__*/React__default.createElement("div", {
        className: classes
      }, showBackButton && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: cnHeader
      }, /*#__PURE__*/React__default.createElement(ButtonLink, {
        className: cnButton,
        title: labelBack,
        onClick: onBack,
        type: "secondary",
        iconSize: "xxs",
        iconLeft: "caret-left"
      })), /*#__PURE__*/React__default.createElement("hr", {
        className: cnBorder
      })), showBanner && /*#__PURE__*/React__default.createElement(Banner, {
        label: labelBanner,
        className: cnBanner
      }), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapper
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnContactHeader
      }, imageUrl && /*#__PURE__*/React__default.createElement(Avatar, {
        image: imageUrl,
        className: cnImage
      }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", {
        className: cnName
      }, name), subline && /*#__PURE__*/React__default.createElement("div", null, subline))), /*#__PURE__*/React__default.createElement("div", {
        className: cnInfo
      }, address && /*#__PURE__*/React__default.createElement("address", {
        className: cnInfoItem
      }, /*#__PURE__*/React__default.createElement("span", null, address.label, ":"), /*#__PURE__*/React__default.createElement("br", null), address.street, " ", /*#__PURE__*/React__default.createElement("br", null), address.zip, " ", /*#__PURE__*/React__default.createElement("br", null)), opening && /*#__PURE__*/React__default.createElement("div", {
        className: cnInfoItem
      }, /*#__PURE__*/React__default.createElement("span", null, opening.label, ":"), /*#__PURE__*/React__default.createElement("br", null), opening.days, " ", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("time", null, opening.time)))), /*#__PURE__*/React__default.createElement("hr", {
        className: cnBorder
      }), /*#__PURE__*/React__default.createElement("div", {
        className: cnWrapper
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnContactList
      }, this.renderContactLink(contactLinks.mail, 'envelope'), this.renderContactLink(contactLinks.phone, 'phone'), this.renderContactLink(contactLinks.web, 'web'))));
    }
  }]);

  return ContactCard;
}(React__default.Component);
ContactCard.propTypes = {
  /** */
  address: PropTypes.shape({
    label: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    zip: PropTypes.string.isRequired
  }),

  /** Additional class name */
  className: PropTypes.string,

  /** */
  contactLinks: PropTypes.shape({
    web: PropTypes.shape(),
    mail: PropTypes.shape(),
    phone: PropTypes.shape()
  }),

  /** */
  imageUrl: PropTypes.string,

  /** */
  labelBack: PropTypes.string,

  /** */
  labelBanner: PropTypes.string,

  /** */
  name: PropTypes.string,

  /** */
  onBack: PropTypes.func,

  /** */
  opening: PropTypes.shape({
    label: PropTypes.string,
    days: PropTypes.string,
    time: PropTypes.string
  }),

  /** */
  showBackButton: PropTypes.bool,

  /** */
  showBanner: PropTypes.bool,

  /** */
  subline: PropTypes.string,

  /** If `true`, the horizontal padding will be increased */
  wide: PropTypes.bool
};

module.exports = ContactCard;
